import { COLORS, 
  i18n,
  usePatchUserUpdateUserPassword,
  //  usePostProfileChangePassword
   } from "core";
import React, { useCallback } from "react";
import { createUseStyles } from "react-jss";
import { Form, Input, message } from "antd";
import { Button, Controller, Paper } from "components/src";
import { FormProvider, useForm } from "react-hook-form";

const PASSWORD = "password";
const NEWPASSWORD = "newPassword";

const useStyle = createUseStyles<string, unknown, COLORS>((colors) => ({
  root: {
    position: "absolute",
    width: "100%",
    height: "100vh",
    alignItems: "center",
    backgroundColor: colors.blue,
  },
  box: {
    borderRadius: "10px",
    height: "95vh",
    margin: "30px",
    boxShadow: "1px 2px 5px #ccc",
    backgroundColor: colors.black,
    textAlign: "center",
  },
  formStyle: {
    Width: "100%",
    margin: "0 auto",
    flex: "0 0 90.333333%",
    textAlign:'center'
  },
  btn: {
    width: "100px",
    margin:'0 auto'
  },
}));

const layout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 16 },
};

const validateMessages = {
  required: "${label}" + " " + i18n.t("isRequired") + "!",
};

const PasswordChange: React.FC = () => {
  const classes = useStyle();
  const methods = useForm({
    defaultValues: {
      password: "",
      newPassword: "",
    },
  });
  const [messageApi, contextHolder] = message.useMessage();
  const { handleSubmit, reset } = methods;
  const { mutate, isPending } = usePatchUserUpdateUserPassword({
    onSuccess: () => {
      reset();
    },
    onError:(error)=>{
      messageApi.open({
        type: "error",
        content:i18n.t((error.message as any).message[0]||(error.message as any).message) ,
      });
       
    }
  });

  const onSubmit = useCallback(
    ({
      password,
      newPassword,
    }: {
      password: any;
      newPassword: any;
    }) => {
      return mutate({
        requestBody: {
          password: password,
          newPassword: newPassword,
        },
      });
    },
    []
  );

  return (
    <>
      {contextHolder}
      <Paper>
        <Form
          {...layout}
          name="nest-messages"
          onFinish={handleSubmit(onSubmit)}
          className={classes.formStyle}
          validateMessages={validateMessages}
        >
          <FormProvider {...methods}>
            <Form.Item
              label={i18n.t("oldPassword")}
              rules={[
                {
                  required: true,
                },
              ]}
              hasFeedback
            >
              <Controller name={PASSWORD}>
                <Input.Password placeholder={i18n.t("oldPassword")} />
              </Controller>
            </Form.Item>

            <Form.Item
              label={i18n.t("newPassword")}
              rules={[
                {
                  required: true,
                },
              ]}
              hasFeedback
            >
              <Controller name={NEWPASSWORD}>
                <Input.Password placeholder={i18n.t("newPassword")} />
              </Controller>
            </Form.Item>

           
            <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 5 }}>
              <Button
                type="primary"
                isLoading={isPending}
                htmlType="submit"
                className={classes.btn}
              >
                {i18n.t("done")}
              </Button>
            </Form.Item>
          </FormProvider>
        </Form>
      </Paper>
    </>
  );
};

export { PasswordChange };
